// extracted by mini-css-extract-plugin
export default {"form":"payments_form__Q5Gn5","column":"payments_column__gO9gx","linkButton":"payments_linkButton__iCv-C"};